// Global error handler for better error management
export function setupGlobalErrorHandling() {
    // Handle unhandled promise rejections
    window.addEventListener('unhandledrejection', (event) => {
        console.error('Unhandled promise rejection:', event.reason);
        
        // Don't show error modal for network errors to avoid spam
        if (event.reason && event.reason.code !== 'ECONNABORTED' && event.reason.message !== 'Request aborted') {
            // Could show a generic error message here if needed
        }
        
        // Prevent the default browser behavior
        event.preventDefault();
    });

    // Handle global JavaScript errors
    window.addEventListener('error', (event) => {
        console.error('Global error:', event.error);
        
        // Don't show error modal for network errors
        if (event.error && event.error.code !== 'ECONNABORTED' && event.error.message !== 'Request aborted') {
            // Could show a generic error message here if needed
        }
    });

    // Handle Vue errors
    if (window.Vue) {
        window.Vue.config.errorHandler = (err, vm, info) => {
            console.error('Vue error:', err, info);
            
            // Don't show error modal for network errors
            if (err && err.code !== 'ECONNABORTED' && err.message !== 'Request aborted') {
                // Could show a generic error message here if needed
            }
        };
    }
}

// Function to check if we're online
export function isOnline() {
    return navigator.onLine;
}

// Function to show offline message
export function showOfflineMessage() {
    if (!isOnline()) {
        console.warn('Application is offline');
        // Could show an offline indicator here
    }
}

// Setup network status monitoring
export function setupNetworkMonitoring() {
    window.addEventListener('online', () => {
        console.log('Application is back online');
        // Could hide offline indicator here
    });

    window.addEventListener('offline', () => {
        console.log('Application is offline');
        showOfflineMessage();
    });
}

// Initialize error handling
export function initErrorHandling() {
    setupGlobalErrorHandling();
    setupNetworkMonitoring();
    showOfflineMessage();
}
